module.exports = __webpack_public_path__ + "img/logo.fw.c0be96e3.png";